import { CoberturaOpcionalTarifa } from './planes';

/**
 * Codigos estables de las coberturas opcionales que el usuario puede activar.
 * Son los que se guardan en el store. updateLead y cotizacion los reciben
 * traducidos con `aCodigosBackend`.
 */
export type CoberturaOpcional = 'PPD';

/**
 * Perdida Parcial. Su tarifa en la respuesta de planes ya suma las
 * subcoberturas PPD (danos) y PPH (hurto).
 */
export const PERDIDA_PARCIAL: CoberturaOpcional = 'PPD';

/**
 * Codigo con el que updateLead y cotizacion esperan cada cobertura opcional, y
 * llave con la que planes entrega su tarifa en `coberturasOpcionales`.
 * Perdida Parcial viaja como 'PPDPPH' porque contrata ambas subcoberturas,
 * danos y hurto.
 */
const CODIGO_BACKEND_COBERTURA_OPCIONAL: Record<CoberturaOpcional, string> = {
  PPD: 'PPDPPH',
};

/** Traduce las coberturas opcionales del store a los codigos del backend. */
export function aCodigosBackend(coberturas: CoberturaOpcional[] = []): string[] {
  return coberturas.map((codigo) => CODIGO_BACKEND_COBERTURA_OPCIONAL[codigo]);
}

/**
 * Tarifa de una cobertura opcional dentro de la respuesta de planes.
 * Se busca primero por el codigo del backend ('PPDPPH', como responde UAT) y
 * luego por el codigo interno ('PPD', como respondia QA), para no depender de
 * que ambos ambientes esten alineados.
 */
export function tarifaCoberturaOpcional(
  tarifas: Record<string, CoberturaOpcionalTarifa> | undefined,
  codigo: CoberturaOpcional,
): CoberturaOpcionalTarifa | undefined {
  return tarifas?.[CODIGO_BACKEND_COBERTURA_OPCIONAL[codigo]] ?? tarifas?.[codigo];
}

/**
 * Unico plan habilitado para ofrecer la cobertura de Perdida Parcial.
 * Aplica en cualquier cilindraje; lo que cambia con el cilindraje es el
 * deducible, no la disponibilidad.
 */
export const PLAN_CON_PERDIDA_PARCIAL = 'MOTOS_PlanPremium';

/**
 * Cilindraje minimo, exclusivo, para considerar una moto de alto cilindraje.
 * Decide la subcobertura Rayones dentro de Pequenos accesorios y la franja de
 * asistencias de alto cilindraje. NO decide si se ofrece Perdida Parcial.
 */
export const CILINDRAJE_MINIMO_ALTO = 250;

